import { useState } from "react";
import ImageModal from "../../components/common/ImageModal";
import { API_BASE_URL } from "../../utilities/constants";
import { handleApiCall } from "../../utilities/helper";

const LookCards = ({ look }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [outfitData, setoutfitData] = useState(null);
  const [controller, setController] = useState(null);

  const images = outfitData?.items//?.map(item => item?.itemImageUrl) || [];

  const callOutfitApi = async () => {
    controller?.abort();
    const newController = new AbortController();
    setController(newController);
    const { signal } = newController;
    setLoading(true);
    try {
      const response = await handleApiCall(
        `${API_BASE_URL}/api/1.0.0/aigenlook/v2/result/${look?.lookId}`,
        {
          method: "GET"
        },
        null,
        signal
      );
      if (response.responseStatus == true) {
        setoutfitData(response.data);
      } else {
        setoutfitData(null);
      }
      if (response.responseCode !== 299) {
        setLoading(false);
      }
    } catch (e) {
      console.error("Error", e);
    } finally {
      setLoading(false);
    }
  };

  const handleViewOutfit = async () => {
    await callOutfitApi();
    setIsModalOpen(true);
  };
  return (

    <div className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden">
      <div className="relative w-full h-80 overflow-hidden">
        <img
          src={look?.imageUrl}
          alt={look.style}
          className="w-full h-full object-contain"
        />
        <span className="absolute top-2 right-2 bg-green-600 text-white text-xs px-2 py-1 rounded-md">
          {look?.status}
        </span>
      </div>

      <div className="p-4 space-y-2">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold">{look?.style || "-"}</h3>
          <span className="text-sm text-gray-500">{look?.vibe || "-"}</span>
        </div>

        <div className="text-sm text-gray-600">
          <span className="capitalize">{look.gender.toLowerCase()}</span>, Age {look?.age || "-"}
        </div>

        <div className="mt-3">
          <h4 className="text-sm font-medium mb-1 text-gray-700">Items:</h4>
          <ul className="text-sm text-gray-600 space-y-1 max-h-24 overflow-y-auto">
            {look?.items?.map((item) => (
              <li
                key={item?.id}
                className="flex justify-between border-b border-gray-100 pb-1"
              >
                <span className="font-medium capitalize">{item?.itemType || "-"}</span>
                <span>{item?.itemName || "-"}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* {images?.length > 0 && ( */}
        {/* <button
            onClick={() => setIsModalOpen(true)}
            className="mt-4 w-full bg-brand-600 hover:bg-brand-700 text-white text-sm font-medium rounded-md px-4 py-2 transition-all"
          >
            View Outfit
          </button> */}
        {/* )} */}
        <button
          onClick={handleViewOutfit}
          className="mt-4 w-full bg-brand-600 hover:bg-brand-700 text-white text-sm font-medium rounded-md px-4 py-2 transition-all disabled:opacity-70"
          disabled={loading}
        >
          {loading ? "Loading Outfit..." : "View Outfit"}
        </button>
      </div>

      {/* Outfit Modal */}
      {isModalOpen && (
        <ImageModal images={images} outfitData={outfitData} onClose={() => setIsModalOpen(false)} />
      )}
    </div>
  );
};

export default LookCards;
